import classNames from "classnames";
import React from "react";
import { Separator } from "../elements/Separator";
import { lookupColourString } from "../lookups";
import { HalfWidthClassName, MainWidthClassName } from "../styles";
import { CollectionProps } from "./Collection";

export const RowCollection: React.FC<CollectionProps> = ({
  title,
  contents,
}) => {
  return (
    <section
      data-component="Row Collection"
      className={classNames(
        "py-50px",
        lookupColourString("Hyacinth", "bg"),
        lookupColourString("Hyacinth", "textForBg"),
      )}
    >
      <div className="page-grid max-width relative">
        {title && (
          <h2
            className={classNames(
              "relative",
              "h2",
              "my-20px",
              "lg:mb-96px",
              HalfWidthClassName,
            )}
          >
            {title}
          </h2>
        )}
        {contents?.map(({ content }, i) => {
          return (
            <div
              key={i}
              className={classNames("relative", MainWidthClassName, "w-full")}
            >
              {content}
              <Separator spaceClass="my-10px lg:my-20px" />
            </div>
          );
        })}
      </div>
    </section>
  );
};
